/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTriangleLeft: {
  name: 'triangle-left';
  data: string;
} = {
  name: 'triangle-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M10 12V4L6 8l4 4Z" fill="currentColor"/></svg>`,
};
